import fileSys from "../../fileoprators/fileSystem";
import { checkCfg, isDefined, isTrue, objectCopy } from "../../shared/utils";
import QSConfig from "../../topography/config/qs";
import { FILES } from "../../topography/shared";
import SettingsOprator from "../settingsoprator";
const DEFAULTSET = {
  previewIndicatrix: {
    CROSSSIZE: 10,
    LINEWIDTH: 2,
    LINECOLOR: "#0A0"
  },
  CTCenter: {
    len: 5,
    lineColor: "#00f",
    fillColor: "#00f"
  },
  shotMode: "far",
  isAutoShot: true,
  autoMove: {
    updown: true,
    range: 150,
    coarse: {
      range: 20,
      speed: 96
    },
    fine: {
      range: 4,
      speed: 72
    }
  },
  autoShot: {
    delay: 200,
    offsetX: 6,
    offsetY: 6,
    offsetZ: 4
  },
  dirs: {
    offset: 300,
    normalW: 80,
    normalH: 80,
    extendW: 30,
    extendH: 30,
    updownW: 400,
    updownH: 400
  },
  handleXY: {
    offsetX: 500,
    offsetY: 300
  },
  handleZ: {
    offsetX: 100,
    offsetY: 100
  }
};
const DEFAULTCENTERPOS = {
  CenterPoint: {
    x: 512,
    y: 384,
    r: 200,
    r1: 200,
    r2: 200
  },
  Roi: {
    r: 100,
    focusLimit: 20
  },
  CenterCamCalib: {
    meibomian: 0.01287186492981831,
    tearheight_infrared: 0.010707186492981831,
    tearheight: 0.010707186492981831,
    nibut: 0.010707186492981831,
    pupilcornea: 0.010707186492981831,
    pupilcornea_infrared: 0.010707186492981831,
    toponear: 0.00947,
    topofar: 0.010565831804575349
  },
  Ring: {
    compensate: -0.06
  }
};
class Shot extends SettingsOprator {
  constructor() {
    super(fileSys.getCalibPath("shotSettings.json"), DEFAULTSET);
    this.specialProcess();
    this.calibPath = fileSys.getCalibPath(FILES.calib);
  }
  specialProcess() {
    fileSys.deleteFile(fileSys.getCfgPath("shotSettings.json"));
    fileSys.deleteFile(fileSys.getTopographyCfgPath("shotSettings.json"));
  }
  getShotSettings() {
    let settings = this.getSettings();
    let autoShot = settings.autoShot;
    let qs = new QSConfig().QS.values;
    let x, y, z;
    for (let id in qs) {
      const key = qs[id].key;
      if (key === "OffsetZ") {
        z = qs[id].min;
      } else if (key === "OffsetX") {
        x = qs[id].min;
      } else if (key === "OffsetY") {
        y = qs[id].min;
      }
    }
    if (autoShot.offsetX !== x || autoShot.offsetY !== y || autoShot.offsetZ !== z) {
      autoShot.offsetX = x;
      autoShot.offsetY = y;
      autoShot.offsetZ = z;
      this.saveSettings(settings);
    }
    return settings;
  }
  saveShotSettings(settings) {
    this.saveSettings(settings);
  }
  getCalibSettings() {
    let settings = fileSys.readIniFile(this.calibPath);
    let isSaveBoolean = false;
    if (isDefined(settings)) {
      let check = checkCfg();
      isSaveBoolean = check(settings, DEFAULTCENTERPOS);
      check = null;
    } else {
      settings = objectCopy(DEFAULTCENTERPOS);
      isSaveBoolean = true;
    }
    if (isTrue(isSaveBoolean)) {
      fileSys.writeIniFile(this.calibPath, settings);
    }

    return settings;
  }
  saveCalibSettings(settings) {
    fileSys.writeIniFile(this.calibPath, settings);
  }
}
export default Shot;



// WEBPACK FOOTER //
// ./src/settings/topography/ctShotInfo.js